<template>
  <div>
    <!--    页面标题 start -->
    <div v-web-title :data-title="$t('message.home.title')"></div>
    <!--    页面标题 end -->

    <!--    页面搜索 start  -->
    <div class="banner">
      <div class="bannerImg">
        <el-carousel trigger="click" autoplay arrow="'none'" indicator-position="none">
          <el-carousel-item v-for="item in bannerList" :key="item">
            <img :src=item alt="">
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="title">
        StarLand Stays Modern, clean, and made for your comfort
      </div>
      <!-- <div class="banner-title">
				<Button type="primary" style="height: auto;" @click="toLink">
					<span class="search-button-text"
						style="font-size: 5rem !important;"> {{$t('message.home.beginTravel')}}</span>
				</Button>
			</div> -->
      <div class="nav">
        <div class="item" @click="toLink(1)">
          <img src="@/assets/img/h_item1.png" alt="" />
          <div class="item-buttom">Book a Room →</div>
        </div>
        <div class="item" @click="toLink(2)">
          <img src="@/assets/img/h_item2.png" alt="" />
          <div class="item-buttom">Rent a Car →</div>
        </div>
        <div class="item" @click="toLink(3)">
          <img src="@/assets/img/h_item3.png" alt="" />
          <div class="item-buttom">Airport pick-up →</div>
        </div>
      </div>

      <!-- <div class="search-block"> -->
      <!-- <DatePicker :open="isDatePickerOpen" type="daterange"
                            :options="disabledDates"
                            placement="bottom"
                            @on-change="datePickerChange"
                            :value="datePickerValue">
                    <div class="input-block">
                        <Input ref="checkinDate" :placeholder="$t('message.home.checkinDate')"
                               class="checkin-date"
                               :value="checkinDateStr"
                               readonly
                               @on-focus="openDatePicker"
                               @on-blur="closeDatePicker"/>
                        <Input ref="checkoutDate" :placeholder="$t('message.home.checkoutDate')"
                               class="checkout-date"
                               :value="checkoutDateStr"
                               readonly
                               @on-focus="openDatePicker"
                               @on-blur="closeDatePicker"/>
                    </div>
                </DatePicker> -->
      <!-- <div class="nights">{{totalNightsStr}}</div>
                <Button type="primary" @click="searchRoom">
                    <Icon type="ios-search" size="16" color="white"></Icon>
                    <span class="search-button-text"> {{$t('message.home.search')}}</span>
                </Button> -->
      <!-- </div> -->
    </div>
    <!--    页面搜索 end  -->

    <!--      活动展示 start -->
    <!-- <Row type="flex" justify="center" class="activity-block">
			<i-col span="18" class-name="test">
				<div class="activity-title">{{$t('message.home.activityShow')}}</div>
			</i-col>
		</Row>
		<Row type="flex" justify="center">
			<i-col span="18" class-name="activity-list">

				<div v-for="activity in activityData" :key="activity.id" class="activity">
					<div class="activity-img">
						<img :src="activity.img" alt="activity.name">
					</div>
					<div class="bottom-block">
						<div class="activity-name">{{activity.name}}</div>
						<div class="start-end-time">
							<div class="time-wrapper">
								<Icon type="md-arrow-dropright-circle" size="20" color="#00C957" />
								<span>2020-06-20</span>
							</div>
							<div class="time-wrapper">
								<Icon type="md-radio-button-on" size="20" color="red" />
								<span>2020-07-20</span>
							</div>
						</div>
					</div>
				</div>

			</i-col>

		</Row> -->

    <!--      活动展示 end -->

    <!--      积分兑换 start -->
    <!-- <Row type="flex" justify="center" class="activity-block">
			<i-col span="18" class-name="test">
				<div class="activity-title">{{$t('message.home.redeemProduct')}}</div>
			</i-col>
		</Row>
		<Row type="flex" justify="center">
			<i-col span="18" class-name="score-product-list">
				<div v-for="product in redeemableProductList" :key="product.id" class="score-product">
					<img class="score-product-img" :src="product.src" :alt="product.name">
					<div class="score-product-name">{{product.name}}</div>
				</div>
			</i-col>

		</Row> -->
    <!--      积分兑换 end -->
    <LoginModal
      :is-show-login="isShowLoginModal"
      @updateShowLoginModalStatus="setIsShowLoginModal"
    />
  </div>
</template>

<script>
// @ is an alias to /src
import LoginModal from "@/components/LoginModal/LoginModal";

import { empty, gotoPage, urlRequest } from "../../common/common";
import moment from "moment";
import { mapMutations, mapState } from "vuex";

export default {
  name: "Home",

  data() {
    return {
      isShowLoginModal: false,
      // 入店日期文本
      checkinDateStr: "",
      // 离店日期文本
      checkoutDateStr: "",
      // 入住晚数文本
      totalNightsStr: "",
      // 酒店基本信息
      motelInfo: [],
      // 活动信息
      activityData: [],
      // 可积分兑换物口数据
      redeemableProductList: [],
      // 日期选择器开关
      isDatePickerOpen: false,
      // 日期选择器值
      datePickerValue: "",
      //轮播图列表
      bannerList: [],
      // 入住晚数
      totalNights: 0,
      // 禁用日期
      disabledDates: {
        disabledDate(date) {
          return date && moment(date).isBefore(moment().subtract(1, "d"));
        },
      },
      // 入住日期
      checkinDate: {},
      // 离店日期
      checkoutDate: {},
    };
  },
  components: {
    LoginModal,
  },
  created() {
    // 默认显示英文
    let lang = "en";
    this.$i18n.locale = lang;
    localStorage.setItem("lang", lang);
  },

 

  methods: {
    
    getBannerList() {
      urlRequest({
        url: this.api.getBannerList,
        method: "GET",
        data:{}
      }).then((res) => {
        console.log('res', res);
        this.bannerList = res.data.data.map((item)=>item.imgurl);
        console.log('this.bannerList', this.bannerList);
      });
    },

   
    toLink(flag) {
      switch (flag) {
        case 1:
            this.$router.push({
              path:"/code",
              query:{
                flag:flag
              }
            });
          break;
        case 2:
          if (this.isLogin) {
            // location.href = "https://toprental.co.nz/";
            this.$router.push({
              path:"/code",
              query:{
                flag:flag
              }
            });
          } else {
            this.isShowLoginModal = true;
          }
          break;
        case 3:
          if (this.isLogin) {
            // location.href = "https://toprental.co.nz/";
            this.$router.push("/reservation");
          } else {
            this.isShowLoginModal = true;
          }
          break;
        default:
          break;
      }
    },
  },
 mounted() {
    console.log("lang: ", navigator.language);
    this.getBannerList();
    // // 从缓存获取入住和离店日期
    // this.getDatesFromStorage();
    // // 获取酒店基本信息
    // this.getMotelInfo();
    // // 获取活动信息
    // this.getActivityInfo();
    // // 获取积分兑换信息
    // this.getRedeemableProduct();
  },
  computed: {
    ...mapState([
      // 是否登录状态
      "isLogin",
      "userInfo",
    ]),
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/mainStyle.scss";
@import "home.scss";
</style>
